// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1___c2d678b5ce2fac9c4d0","cls2":"TruncateHeight-cls2___979eced37014148e790 TruncateHeight-cls1___c2d678b5ce2fac9c4d0"};